import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { StudentInfo } from "../student/studentSlice";

export interface ClassroomRemoveStudentState {
  state: LoadStateInfo;
  student?: StudentInfo;
}

const initialState: ClassroomRemoveStudentState = {
  state: notStarted(),
};

export interface ClassroomRemoveStudentRequest {
  classroomId: string;
  student: StudentInfo;
}
export const classroomDeleteStudent = createAsyncThunk(
  "classroomDeleteStudent",
  async (param: ClassroomRemoveStudentRequest, thunkAPI) => {
    console.debug( `classroom remove student ${param.student.id} from ${param.classroomId}`);
    const response = await fetch(`${getBackendUrl()}/api/classroom/${param.classroomId}/student/${param.student.id}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    if(response.ok) {
      return "OK";
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const classroomRemoveStudentSlice = createSlice({
  name: "classroomRemoveStudent",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.student = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(classroomDeleteStudent.pending, (state, action) => {
        state.state =  loading();
        state.student = action.meta.arg.student;
      })
      .addCase(classroomDeleteStudent.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(classroomDeleteStudent.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = classroomRemoveStudentSlice.actions;

export const selectClassroomRemoveStudent = (state: RootState) => state.classroomRemoveStudent;

export default classroomRemoveStudentSlice.reducer;
